import police from "../../../assets/img/hero/police.png"
import thane1 from "../../../assets/img/pv/thane1.jpg"
import thane2 from "../../../assets/img/pv/thane2.jpg"

import Head from "../../sections/Head";
import Footer from "../../sections/Footer";


const Thane_Police_Verification = () => {
    return (
        <>
            <Head />
            <section className="manage-data-area pt-10 pb-10">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="manage-data-image content-right-spacer animate-float-bob-y text-center" >
                                <img
                                    src={police}
                                    alt="Manage Data"
                                    loading="lazy"
                                    width="400px"
                                    height="400px"

                                />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="section-title section-title-tuna">
                                <h2>
                                    Tenant's Police  <span>Verification</span>
                                </h2>
                                <div className="section-title-quote">
                                    <p>Now Citizens can submit the tenant’s information while submitting the Leave and License Agreement Online. No additional process would be required.</p>
                                </div>
                                <div className="section-title-description">
                                    <p>
                                    Recently there is a new option introduced to submit tenants information while submitting the agreement for registration. Such information will be automatically shared with the Police Station which the user has selected while submitting the form. 
                                   </p>
                                   <p>
                                       <a className="btn btn-link" href="https://efilingigr.maharashtra.gov.in/ereg/" rel="noopener noreferrer" target="_blank"> https://efilingigr.maharashtra.gov.in/ereg/</a> (Note - This Service is available for selected Location 
                                    Pune District and some other locations Mumbai And Other locations have to be go with offline process 
                                    and in some locations citizens can use online tenant Intimations websites). It is advisable that every landlord should register the Leave and License Agreement and submit their tenant’s
                                     information to the nearest Police Chowki.
                                    </p>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section
                className="simple-cta-area bg-royal-blue"
              
                loading="lazy"
            >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-10">
                            <div className="simple-cta-content">
                                <h4>
                                   Sample of Police Verification For Tenant
                                </h4>
                                <a href="/form.pdf" rel="noopener noreferrer" target="_blank" 
                                    className="filled-btn btn-bordered btn-off-white">
                                   Download Sample Form<i className="fas fa-arrow-right"></i>
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="app-statistic-area pt-35 pb-35">
			<div className="container">
				<div className="row">
				
                    <div className="col-lg-6 ">
						<div className="square-and-oval-image-wrapper ">
							<div className="image-square">
								<img src={thane1} alt="police verification"   loading="lazy" />
							</div>

						</div>
					</div>

					<div className="col-lg-6 ">
						<div className="square-and-oval-image-wrapper ">
							<div className="image-square">
								<img src={thane2} alt="police verification"   loading="lazy" />
							</div>

						</div>
					</div>

                                <div className="section-button-wrapper  text-center pt-35">
											<span>
												<a href="/thane_police_verification.pdf" rel="noopener noreferrer" target="_blank" className="filled-btn">
													Download Police Verification<i className="fas fa-arrow-right"></i>
												</a>
											</span>
											
										</div>
				</div>
			</div>
		</section>
            <Footer />
        </>

    );
};

export default Thane_Police_Verification;